const translations = {
    allData: 'All Data',
    applications: 'Applications',
    assets: 'Assets',
    boundaries: 'Boundaries',
    clients: 'Clients',
    farms: 'Farms',
    fields: 'Fields',
    users: 'Users'
};

export default translations;
